module.exports = __webpack_public_path__ + "img/logo-matrix.1dd58e27.png";